// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"5b935e20","473":"dfb6f50f","550":"9c6d37ca","706":"521d82a6","752":"041be48b","941":"0c19b086","992":"3e72f187"}[chunkId] + ".js";
};